import { render, staticRenderFns } from "./EmailUnsubscribers.vue?vue&type=template&id=afa6cabe&scoped=true&"
import script from "./EmailUnsubscribers.vue?vue&type=script&lang=js&"
export * from "./EmailUnsubscribers.vue?vue&type=script&lang=js&"
import style0 from "./EmailUnsubscribers.vue?vue&type=style&index=0&id=afa6cabe&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa6cabe",
  null
  
)

export default component.exports